/*eslint-disable spaced-comment */
/*eslint-disable eqeqeq */
const payments = {
  state: {
    paymentMethods: [
      // {
      //   "billing_details": {
      //       "address": {
      //           "city": null,
      //           "country": null,
      //           "line1": null,
      //           "line2": null,
      //           "postal_code": "21212",
      //           "state": null
      //       },
      //       "email": null,
      //       "name": "abcd",
      //       "phone": null
      //   },
      //   "card": {
      //       "brand": "visa",
      //       "checks": {
      //           "address_line1_check": null,
      //           "address_postal_code_check": "pass",
      //           "cvc_check": "pass"
      //       },
      //       "country": "FR",
      //       "exp_month": 4,
      //       "exp_year": 2032,
      //       "fingerprint": "zwCETmGhF5cYr9dD",
      //       "funding": "credit",
      //       "generated_from": null,
      //       "last4": "3155",
      //       "networks": {
      //           "available": [
      //               "visa"
      //           ],
      //           "preferred": null
      //       },
      //       "three_d_secure_usage": {
      //           "supported": true
      //       },
      //       "wallet": null
      //   },
      //   "created": 1594171383,
      //   "customer": "cus_HbcrAqO0WJJyMp",
      //   "id": "pm_1H2S03IZCI3g2dqzumScnpCa",
      //   "livemode": false,
      //   "metadata": {},
      //   "object": "payment_method",
      //   "type": "card"
      // },
    ]
  },

  getters: {
    getPaymentMethods: state => () => {
      return state.paymentMethods;
    },

    getPaymentMethod: state => id => {
      return state.paymentMethods.find(paymentMethod => paymentMethod.id == id);
    }
  },

  mutations: {
    addPaymentMethods(state, paymentMethods) {
      state.paymentMethods = paymentMethods;
    },

    addPaymentMethod(state, paymentMethod) {
      state.paymentMethods.push(paymentMethod);
    },

    updatePaymentMethod(state, paymentMethod) {
      let index = state.paymentMethods.findIndex(
        item => item.id === paymentMethod.id
      );

      if (index > -1) {
        state.paymentMethods.splice(index, 1, paymentMethod);
      }
    },

    removePaymentMethod(state, id) {
      state.paymentMethods = state.paymentMethods.filter(
        paymentMethod => paymentMethod.id !== id
      );
    }
  }
};

export default payments;



// WEBPACK FOOTER //
// ./src/store/payments.js